import OptimizeImage from './OptimizeImage';
export default OptimizeImage;